import { getCrmSuiteProductLevelForSkuIds, getProductForSkuId, getProductSkuIdIsBundle, getSkuIdIsAddonOrService, getSkuIdIsInCrmSuite } from 'pricing-pages-lib/utils/productsUtils';
import ApiNameToUpgradeProductMap from 'self-service-api/constants/ApiNameToUpgradeProductMap';
import { SERVICE } from 'self-service-api/constants/ProductTypes';
import QuantityPackToUpgradeProduct from 'self-service-api/constants/QuantityPackToUpgradeProduct';
import { PRODUCT_VERSION, QUANTITY_PACK } from 'self-service-api/constants/SkuTypes';
import { BUNDLE } from 'self-service-api/constants/UpgradeProducts';
const getSingleProductOrNull = (state, {
  skuIds
}) => {
  const {
    productData: {
      skuMap
    }
  } = state;

  // Things that count as single product:
  // 1. Basically any non-addon or non onboarding (additional seats, contacts, single hub).
  // We don't want to filter those out if they are all that's there
  // Fist check for those
  if (skuIds.length === 1) {
    if (!getSkuIdIsAddonOrService(state, {
      skuId: skuIds[0]
    })) {
      return skuIds[0];
    }
    if (getProductSkuIdIsBundle(state, {
      skuId: skuIds[0]
    })) {
      return skuIds[0];
    }
    return null;
  }

  // 2. Any hub +/- it's corresponding children SKUs (seats or contacts) and +/- onboarding
  // So let's filter those out
  const filteredSkuIds = skuIds.filter(skuId => {
    const product = getProductForSkuId(state, {
      skuId
    });
    const {
      skuType
    } = skuMap[skuId];
    return product.productType !== SERVICE && skuType === PRODUCT_VERSION;
  });
  return filteredSkuIds.length === 1 && filteredSkuIds[0];
};
export const getUpgradeProduct = (state, {
  skuIds
}) => {
  const {
    productData: {
      skuMap
    }
  } = state;
  const suiteProductLevel = getCrmSuiteProductLevelForSkuIds(state, {
    skuIds
  });
  const isOnlySuite = suiteProductLevel && skuIds.every(skuId => getSkuIdIsInCrmSuite(state, {
    skuId,
    suiteProductLevel
  }));
  if (isOnlySuite && suiteProductLevel) {
    return `suite-${suiteProductLevel.toLowerCase()}`;
  }
  const singleProductSkuId = getSingleProductOrNull(state, {
    skuIds
  });
  if (singleProductSkuId) {
    const sku = skuMap[singleProductSkuId];
    const {
      apiName
    } = getProductForSkuId(state, {
      skuId: singleProductSkuId
    });
    if (sku.skuType === QUANTITY_PACK) {
      const {
        quantityUnit: {
          unitType
        }
      } = sku;
      const unitTypeToUpgradeProduct = QuantityPackToUpgradeProduct[apiName];
      if (unitTypeToUpgradeProduct) {
        const upgradeProduct = unitTypeToUpgradeProduct[unitType];
        if (upgradeProduct) {
          return upgradeProduct;
        }
      }
    }
    const upgradeProduct = ApiNameToUpgradeProductMap[apiName];
    if (upgradeProduct) {
      return upgradeProduct;
    }
  }
  return BUNDLE;
};